import { render } from "./TournamentCategoryEditPage.vue?vue&type=template&id=7dd4591a"
import script from "./TournamentCategoryEditPage.vue?vue&type=script&lang=js"
export * from "./TournamentCategoryEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__